import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import { logger } from '@/lib/utils/logger';
import { LegalExpertsResource } from '@/types';

const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

const getInitials = (fullName: string | null | undefined) => {
  if (!fullName) return '';
  const words = fullName.split(' ');

  let initials = '';

  words.forEach((word) => {
    if (word.length > 0) {
      initials += word[0].toUpperCase();
    }
  });

  return initials.slice(0, 2);
};

const isValidUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

const getMockExperts = (): LegalExpertsResource[] => {
  const mockExperts = [
    {
      id: '2z333',
      expert_image: null,
      name: 'Sarah C.',
      location_formatted: 'Québec, Québec',
      description:
        "Je pratique le droit depuis plus de 10 ans. Je me spécialise dans les cas d'éviction et d'augmentation de loyer.",
      rating: {
        score: 4.9,
        total_ratings: 34,
      },
      fields_of_expertise: {
        main_fields: ['Éviction', 'Augmentation de loyer'],
        total_remaining_formatted: '+8',
      },
    },
    {
      id: '3z333',
      expert_image: null,
      name: 'Félix V.',
      location_formatted: 'Gatineau, Québec',
      description:
        'I am a solo practitioner with offices in Montreal. I specialized in residential law and mortgages.',
      rating: {
        score: 4.9,
        total_ratings: 29,
      },
      fields_of_expertise: {
        main_fields: ['Résidentiel', 'Hypothèques'],
        total_remaining_formatted: '+3',
      },
    },
    {
      id: '4z333',
      expert_image: null,
      name: 'Lara O.',
      location_formatted: 'Beloeil, Québec',
      description:
        "Je suis avocate depuis 6 ans, et j'accompagne les propriétaires de logement dans les démarches légales entourant la location de leur(s) logement(s).",
      rating: {
        score: 4.8,
        total_ratings: 13,
      },
      fields_of_expertise: {
        main_fields: ['Location de logement'],
        total_remaining_formatted: '+2',
      },
    },
  ];

  return mockExperts;
};

export { cn, getInitials, isValidUrl, getMockExperts, logger };
